import AppHeaderContents, { AppHeaderContentsProps } from './AppHeaderContents';

export default AppHeaderContents;
export type { AppHeaderContentsProps };
